// @figma file=pkCGby54zXzTsccXvHqzO6 node=tbd name="Calendar" set="mytaible-shadcn-studio" verified=tbd

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { DayPicker, type DayPickerProps } from 'react-day-picker';
import { cn } from '../../lib/utils';

// ─── Props ────────────────────────────────────────────────────────────────────

export type CalendarProps = DayPickerProps;

// ─── Calendar ─────────────────────────────────────────────────────────────────

const Calendar = ({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) => (
  <DayPicker
    showOutsideDays={showOutsideDays}
    className={cn('p-3', className)}
    classNames={{
      months: 'flex flex-col sm:flex-row gap-4',
      month: 'flex flex-col gap-4',
      month_caption: 'flex justify-center pt-1 relative items-center',
      caption_label: 'text-sm font-medium',
      nav: 'flex items-center gap-1',
      button_previous: cn(
        'absolute left-1 h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100',
        'inline-flex items-center justify-center rounded-[var(--radius)] border border-border',
      ),
      button_next: cn(
        'absolute right-1 h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100',
        'inline-flex items-center justify-center rounded-[var(--radius)] border border-border',
      ),
      month_grid: 'w-full border-collapse space-x-1',
      weekdays: 'flex',
      weekday: 'text-muted-foreground rounded-md w-9 font-normal text-xs flex-1 text-center',
      week: 'flex w-full mt-2',
      day: 'text-center text-sm p-0 relative flex-1 focus-within:relative focus-within:z-20',
      day_button: cn(
        'h-9 w-9 p-0 font-normal mx-auto rounded-[var(--radius)]',
        'hover:bg-accent hover:text-accent-foreground',
        'focus-visible:bg-accent focus-visible:text-accent-foreground',
        'inline-flex items-center justify-center',
        'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1',
      ),
      selected:
        'bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground rounded-[var(--radius)]',
      today: 'bg-accent text-accent-foreground rounded-[var(--radius)]',
      outside: 'day-outside text-muted-foreground opacity-50',
      disabled: 'text-muted-foreground opacity-50',
      range_middle: 'aria-selected:bg-accent aria-selected:text-accent-foreground',
      hidden: 'invisible',
      ...classNames,
    }}
    components={{
      Chevron: ({ orientation }) =>
        orientation === 'left' ? (
          <ChevronLeft className="h-4 w-4" aria-hidden="true" />
        ) : (
          <ChevronRight className="h-4 w-4" aria-hidden="true" />
        ),
    }}
    {...props}
  />
);
Calendar.displayName = 'Calendar';

export { Calendar };
